import { Cloud, CloudSlash } from "@phosphor-icons/react";
import { T } from "../themes";
import Spinner from "./Spinner";

export default function SyncBadge({ syncing, error }) {
  if (syncing) return (
    <span style={{display:"flex",alignItems:"center",gap:4,color:T.yellow,fontSize:9,fontFamily:T.fontSans,fontWeight:"bold"}}>
      <Spinner size={10}/> Syncing
    </span>
  );
  if (error) return (
    <span style={{display:"flex",alignItems:"center",gap:4,color:T.red,fontSize:9,fontFamily:T.fontSans,fontWeight:"bold"}}>
      <CloudSlash size={10}/> Offline
    </span>
  );
  return (
    <span style={{display:"flex",alignItems:"center",gap:4,color:T.success,fontSize:9,fontFamily:T.fontSans,fontWeight:"bold"}}>
      <Cloud size={10}/> Synced
    </span>
  );
}
